import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  Flex,
  Box,
  FormControl,
  Switch,
  FormLabel,
  Input,
} from "@chakra-ui/react";
import { RiDeleteBinLine } from "react-icons/ri";
import {
  setEditingMode,
  removeDropItem,
  updateField,
} from "../../../redux/actions/formActions";
import DragIcon from "../Icons/Drag";
const TextField = ({
  field,
  uid: fieldId,
  isFocused,
  dispatchSetEditingMode,
  dispatchRemoveDropItem,
  dispatchUpdateField,
}) => {
  const handleOnChange = (e) => {
    e.stopPropagation();
    const value = e.target.checked;
    const updatedField = {
      ...field,
      isRequired: value,
    };
    return dispatchUpdateField(updatedField);
  };

  const handleEditOnClick = (e) => {
    const eventType = e.target.type;
    if (!eventType) {
      dispatchSetEditingMode(fieldId);
    }
  };

  const handleDeleteOnClick = (e) => {
    e.stopPropagation();
    return dispatchRemoveDropItem(fieldId);
  };
  return (
    <Flex
      onClick={handleEditOnClick}
      cursor="pointer"
      // p="3"
      border={isFocused ? "2px solid #3182ce" : "none"}
      bg="#F5F7F9"
      align="center"
      justify="space-around"
      mb="3"
      w="592px"
      h="112px"
      borderRadius="4px"
    >
      <div
        style={{
          marginBlockEnd: "auto",
          marginTop: "12px",
          marginLeft: "8px",
          marginRight: "9px",
        }}
      >
        <DragIcon />
      </div>
      <FormControl isRequired={field.isRequired} w="500px">
        {field.showLabel && (
          <FormLabel fontSize="14px" mb="4px">
            {field.label}
          </FormLabel>
        )}
        <Input
          w="500px"
          h="32px"
          type="text"
          borderRadius="4px"
          border="1px"
          borderStyle="solid"
          borderColor="#CFD7DF"
          placeholder={field.placeholder}
          bg="#FFFFFF"
        />
        <Box mt="8px" w="100%">
          <FormControl
            w="100%"
            justifyContent="flex-end"
            display="flex"
            alignItems="center"
          >
            <Switch isChecked={field.isRequired} onChange={handleOnChange} />
            <FormLabel fontSize="14px" ml="2">
              Required
            </FormLabel>
          </FormControl>
        </Box>
      </FormControl>
      <div
        style={{
          marginBlockEnd: "auto",
          marginTop: "12px",
          marginLeft: "16px",
          marginRight: "16px",
        }}
      >
        <RiDeleteBinLine cursor="pointer" onClick={handleDeleteOnClick} />
      </div>
    </Flex>
  );
};

TextField.propTypes = {
  field: PropTypes.object.isRequired,
  isFocused: PropTypes.bool,
  uid: PropTypes.string.isRequired,
  dispatchSetEditingMode: PropTypes.func.isRequired,
  dispatchRemoveDropItem: PropTypes.func.isRequired,
  dispatchUpdateField: PropTypes.func.isRequired,
};

const getFocusFieldId = (state) => {
  const { focusField } = state.form;
  return focusField && focusField.uid ? focusField.uid : null;
};

const getFieldById = (state, isFocused, uid) => {
  const { dropped, focusField } = state.form;
  return isFocused ? focusField : dropped.find((field) => field.uid == uid);
};

const isCurrentlyFocused = (state, uid) => {
  const { isEditing } = state.form;
  return isEditing && getFocusFieldId(state) == uid;
};

const mapStateToProps = (state, ownProps) => {
  const { uid } = ownProps;
  const isFocused = isCurrentlyFocused(state, uid);
  const field = getFieldById(state, isFocused, uid);
  return {
    field,
    isFocused,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchSetEditingMode: bindActionCreators(setEditingMode, dispatch),
    dispatchRemoveDropItem: bindActionCreators(removeDropItem, dispatch),
    dispatchUpdateField: bindActionCreators(updateField, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextField);
